import {Record, List} from "immutable"

interface Properties {
    id: number
    fullName: string
    position: string
    contacts?: List<string>
}

export class Person extends Record({
    id: undefined,
    fullName: undefined,
    position: undefined,
    contacts: undefined,
}) implements Properties {
    id: number
    fullName: string
    position: string
    contacts: List<string> | undefined

    constructor(values: Properties) {
        super(values)
    }
}

export type JsonData =  {
    id: number
    fullName: string
    position: string
    contacts?: string[]
}

export const fromJs = ({
    id,
    fullName,
    position,
    contacts,
}: JsonData): Person => {
    let data: Properties = {
        id,
        fullName,
        position,
    }

    if (contacts) {
        data.contacts = List(contacts)
    }

    return new Person(data)
}